"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExclusiveGatewayViewModel = void 0;
const GatewayBaseViewModel_1 = require("./GatewayBaseViewModel");
class ExclusiveGatewayViewModel extends GatewayBaseViewModel_1.GatewayViewModel {
}
exports.ExclusiveGatewayViewModel = ExclusiveGatewayViewModel;
//# sourceMappingURL=ExclusiveGatewayViewModel.js.map